import BreadCrumb from "components/Common/BreadCrumb";
import CollapseFilter from "components/Common/CollapseFilter";
import CopyWrapper from "components/Common/CopyWrapper";
import DatePickerCustom from "components/Common/DatePickerCustom";
import DropdownStatusNew from "components/Common/DropdownStatusNew";
import LabelWrapper from "components/Common/LabelWrapper";
import ModalConfirm from "components/Common/ModalConfirm";
import ModalMultiPreview from "components/Common/ModalMultiPreview";
import ModalPreview from "components/Common/ModalPreview";
import TableContainer from "components/Common/TableContainer";
import TooltipCustom from "components/Common/TooltipCustom";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import { COLOR_INQUIRY_STATUS, INQUIRY_STATUS } from "helpers/constans";
import countries from "helpers/countries";
import {
  formatDateStringToKorea,
  formatDateStringToUTC,
  getPlatFormImage,
} from "helpers/format";
import IPHONE_MODELS from "helpers/iphone_models";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import CountUp from "react-countup";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import { createSelector } from "reselect";
import { getInquiryList } from "store/inquiry-list/thunk";
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from "use-query-params";
import { capitalizeFirstLetter, secondsToDhms } from "utils";
import NO_IMAGE_USER from "../../assets/images/no-user.png";

import InquiryListDetail from "./InquiryListDetail";
import moment from "moment";
import inquiryListApi from "api/inquiryListApi";
import CollapseContent from "components/Common/CollapseContent";
import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";

const TYPE_SELECT_DEFAULT: string = "created_at";
registerLocale("en", en);
registerLocale("ko", ko);

const InquiryList = () => {
  const { t, i18n } = useTranslation();
  const [summary, setSummary] = useState<any>();

  const [query, setQuery]: any = useQueryParams({
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 30),
    content: withDefault(StringParam, ""),
    nickname: withDefault(StringParam, ""),
    email: withDefault(StringParam, ""),
    uuid: withDefault(StringParam, ""),
    contactName: withDefault(StringParam, ""),
    contactPhone: withDefault(StringParam, ""),
    contactEmail: withDefault(StringParam, ""),
    type: withDefault(StringParam, ""),
    status: withDefault(StringParam, ""),
    startDate: withDefault(StringParam, ""),
    endDate: withDefault(StringParam, ""),
    // sortBy: withDefault(StringParam, "createdAt"),
    // orderBy: withDefault(StringParam, "desc"),
  });

  const [itemToDelete, setItemToDelete] = useState<any>(false);
  const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false);
  const [linkImage, setLinkImage] = useState<any>(null);
  const [itemToDetail, setItemToDetail] = useState<any>(null);
  const [isShowDetail, setIsShowDetail] = useState<boolean>(false);
  const [tabDetailActive, setTabDetailActive] = useState<any>("");
  const [dataInquiryTypes, setDataInquiryTypes] = useState<any>([]);

  const [contentSearch, setContentSearch] = useState<any>(query?.content || "");
  const [nicknameSearch, setNicknameSearch] = useState<any>(
    query?.nickname || ""
  );
  const [emailSearch, setEmailSearch] = useState<any>(query?.email || "");
  const [uuidSearch, setUUIDSearch] = useState<any>(query?.uuid || "");
  const [contactNameSearch, setContactNameSearch] = useState<any>(
    query?.contactName || ""
  );
  const [contactPhoneSearch, setContactPhoneSearch] = useState<any>(
    query?.contactPhone || ""
  );
  const [contactEmailSearch, setContactEmailSearch] = useState<any>(
    query?.contactEmail || ""
  );
  const [typeSearch, setTypeSearch] = useState<any>(
    dataInquiryTypes?.find(
      (item: any) => String(item?.value) === String(query?.type)
    )?.value || ""
  );
  const [statusSearch, setStatusSearch] = useState<any>(
    INQUIRY_STATUS?.find((item) => item?.value === query?.status)?.value || ""
  );
  const [dateSearch, setDateSearch] = useState<any[]>([
    query?.startDate
      ? moment(query?.startDate || "", "Y-MM-DD").toDate()
      : null,
    query?.endDate ? moment(query?.endDate || "", "Y-MM-DD").toDate() : null,
  ]);
  const [startDate, endDate] = dateSearch;

  const dispatch: any = useDispatch();
  const selectLayoutState = (state: any) => state.InquiryList;
  const AdvertisementProperties = createSelector(
    selectLayoutState,
    (state) => ({
      inquiries: state.inquiries,
      isInquiryLoading: state.isInquiryLoading,
      isInquirySuccess: state.isInquirySuccess,
      error: state.error,
    })
  );

  const { inquiries, isInquiryLoading } = useSelector(AdvertisementProperties);

  const loadTableData = async () => {
    try {
      dispatch(getInquiryList(query));

      const response: any = await inquiryListApi?.summary(query);
      if (response.code == 200) setSummary(response?.data);
    } catch {
    }
  };

  const searchData = () => {
    setQuery({
      ...query,
      content: contentSearch,
      nickname: nicknameSearch,
      email: emailSearch,
      uuid: uuidSearch,
      contactName: contactNameSearch,
      contactPhone: contactPhoneSearch,
      contactEmail: contactEmailSearch,
      type: typeSearch,
      status: statusSearch,
      startDate: startDate
        ? formatDateStringToUTC(
          moment(new Date(startDate))
            .startOf("day")
            .format("Y-MM-DD HH:mm:ss")
        )
        : "",
      endDate: endDate
        ? formatDateStringToUTC(
          moment(new Date(endDate)).endOf("day").format("Y-MM-DD HH:mm:ss")
        )
        : "",
      // sortBy: TYPE_SELECT_DEFAULT,
      page: 1,
    });
  };

  const resetData = () => {
    setQuery(
      {
        content: "",
        nickname: "",
        email: "",
        uuid: "",
        contactName: "",
        contactPhone: "",
        contactEmail: "",
        type: "",
        status: "",
        startDate: "",
        endDate: "",
        sortBy: TYPE_SELECT_DEFAULT,
      },
      "push"
    );

    setContentSearch((_prev: any) => "");
    setNicknameSearch((_prev: any) => "");
    setEmailSearch((_prev: any) => "");
    setUUIDSearch((_prev: any) => "");
    setContactNameSearch((_prev: any) => "");
    setContactPhoneSearch((_prev: any) => "");
    setContactEmailSearch((_prev: any) => "");
    setTypeSearch((_prev: any) => "");
    setStatusSearch((_prev: any) => "");
    setDateSearch([null, null]);
  };

  // Column
  const columns = useMemo(
    () => [
      {
        Header: t("No."),
        thWidth: 80,
        thClass: "align-middle",
        Cell: ({ ...props }) => {
          return (
            <div style={{ display: "inline-flex", minWidth: "60px" }}>
              <div>
                {inquiries?.pagination?.total -
                  ((query?.page - 1) * query?.limit + props?.row?.index)}
              </div>
            </div>
          );
        },
      },
      {
        Header: t("Status"),
        accessor: "status",
        thWidth: 160,
        thClass: "align-middle text-center  whitespace-nowrap",
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;

          return (
            <div className="text-center" style={{ minWidth: 140 }}>
              <span
                className={`rounded-pill badge bg-${COLOR_INQUIRY_STATUS[item?.status] || "secondary"
                  }`}
              >
                {t(
                  INQUIRY_STATUS?.find(
                    (i: any) => String(i?.value) === String(item?.status)
                  )?.label || ""
                )}
              </span>
              <div style={{ fontSize: 11, marginTop: 5 }}>
                {!item?.processingTimeExpired && item?.processTimeElapsed && (
                  <>{t("Timelapsed")} </>
                )}
                {item?.processingTimeExpired && item?.processTimeElapsed && (
                  <>{t("Overdue")} </>
                )}
                {secondsToDhms(
                  item?.processingTimeExpired || item?.processTimeElapsed,
                  t
                )}
              </div>
            </div>
          );
        },
      },
      {
        Header: t("Type"),
        accessor: "inquiryType.name",
        filterable: true,
        sortable: false,
        thClass: "align-middle whitespace-nowrap",
        thWidth: 180,
        Cell: (cell: any) => {
          return <div className="">{cell?.value}</div>;
        },
      },
      {
        Header: t("Content"),
        accessor: "contents",
        filterable: true,
        sortable: false,
        thClass: "align-middle whitespace-nowrap",
        thWidth: 260,
        Cell: (cell: any) => {
          const item = cell?.row?.original;

          return (
            cell?.value && (
              <div 
                className="cursor-pointer text-primary"
                onClick={() => {
                  setItemToDetail(item);
                  setIsShowDetail(false);
                  setTabDetailActive(null);
                }}
                >
                <CopyWrapper
                  contentCopy={cell?.value}
                  style={{ minWidth: "230px", whiteSpace: "pre-line" }}
                >
                  <CollapseContent
                    style={{ maxWidth: "230px" }}
                    dataOriginal={cell?.value}
                    isRank={false}
                    isInlineBlock={true}
                    isShowModal={true}
                    titleModal={t("Content")}
                  />
                </CopyWrapper>
              </div>
            )
          );
        },
      },
      {
        Header: t("Attachments"),
        accessor: "attachments",
        thClass: "align-middle text-center th-border-right-1px pe-2 ",
        filterable: true,
        sortable: false,
        thWidth: 230,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          const isVideo =
            item?.attachments?.[0]?.path &&
            (item?.attachments?.[0]?.type === "video" ||
              (item?.attachments?.[0]?.type === "file" &&
                item?.attachments?.[0]?.path?.includes(".mp4")));
          const imgUrl = item?.attachments?.[0]?.path;
          return imgUrl ? (
            <>
              <div
                className="w-100 text-center  td-border-right-1px  td-border-right-1px "
                style={{ minWidth: "190px" }}
              >
                <div
                  className="m-auto cursor-pointer"
                  onClick={() => {
                    if (item?.attachments?.length > 1) {
                      setLinkImage({
                        urls: item?.attachments?.map((i: any) => {
                          return { ...i, url: i?.path };
                        }),
                        keyword: {
                          title: item?.filename,
                          keyword: item?.filename,
                        },
                        isVideo,
                      });
                    } else {
                      setLinkImage({ url: imgUrl, isVideo });
                    }
                    document.body.className = "modal-open_img";
                  }}
                >
                  {isVideo ? (
                    <video width="160" height="120" controls key={imgUrl}>
                      <source src={imgUrl} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  ) : (
                    <img
                      src={imgUrl}
                      style={{ width: "160px" }}
                      className="flex-shrink-0 rounded"
                      alt="thumbnail"
                    // onError={({ currentTarget }) => {
                    //   currentTarget.onerror = null; // prevents looping
                    //   currentTarget.src = noImageJob;
                    // }}
                    />
                  )}
                </div>
              </div>
            </>
          ) : (
            <div className=" td-border-right-1px "></div>
          );
        },
      },

      {
        Header: t("Account Info"),
        accessor: "Account Info",
        thClass: "align-middle  text-end px-0",
        filterable: false,
        sortable: false,
        thWidth: 860,
        thComponent: () => (
          <table className="th-border-right-1px  chat-log-px-0 w-100">
            <thead>
              <tr>
                <th
                  className="whitespace-nowrap text-center th-border-bottom-1px pb-2 none-sticky"
                  colSpan={4}
                >
                  {t("Account Info")}
                </th>
              </tr>
              <tr>
                <tr>
                  <th
                    className="whitespace-nowrap text-center pb-0 pt-2 cursor-pointer none-sticky"
                    style={{ width: "80px" }}
                  >
                    {t("Avatar")}
                  </th>
                  <th
                    className="whitespace-nowrap text-center pb-0 pt-2 cursor-pointer none-sticky"
                    style={{ width: "200px" }}
                  >
                    {t("Nickname")}
                  </th>
                  <th
                    className="whitespace-nowrap text-center pb-0 pt-2 cursor-pointer none-sticky"
                    style={{ width: "220px" }}
                  >
                    {t("Email")}
                  </th>
                  <th
                    className="whitespace-nowrap text-center pb-0 pt-2 cursor-pointer none-sticky"
                    style={{ width: "140px" }}
                  >
                    {t("Platform")}
                  </th>

                  <th
                    className="whitespace-nowrap text-center pb-0 pt-2 cursor-pointer none-sticky"
                    style={{ width: "200px" }}
                  >
                    {t("UUID")}
                  </th>
                </tr>
              </tr>
            </thead>
          </table>
        ),
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          const avatars: any = item?.user?.profile?.imageUrls;
          const nickName: any = item?.user?.profile?.nickname;
          const email: any = item?.user?.profile?.email;
          let platform = item?.user?.profile?.provider || "email";
          let imgPlatform = getPlatFormImage(platform);
          if (platform === "default") {
            platform = "Email";
          }

          return (
            <div className="d-flex text-center td-border-right-1px chat-log-px-0 align-items-center">
              <div style={{ width: "80px" }}>
                <div
                  className="w-100 text-center "
                  style={{ minWidth: "60px" }}
                >
                  <div
                    style={{ width: "45px" }}
                    className="m-auto cursor-pointer"
                    onClick={() => {
                      const formatAvatars = avatars?.map((item: string) => ({
                        url: item,
                      }));
                      setLinkImage(
                        formatAvatars?.length > 1
                          ? { urls: formatAvatars }
                          : { url: avatars?.[0] || "" }
                      );
                    }}
                  >
                    <img
                      src={avatars?.[0] ?? NO_IMAGE_USER}
                      className="rounded-circle avatar-sm"
                      alt="thumbnail"
                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null; // prevents looping
                        currentTarget.src = NO_IMAGE_USER;
                      }}
                    />
                  </div>
                </div>
              </div>
              <div
                style={{
                  width: "200px",
                  borderLeft: "1px solid #eaeaea",
                  borderRight: "1px solid #eaeaea",
                }}
                className="div-sticky"
              >
                {nickName ? (
                  <div className="cursor-pointer">
                    <CopyWrapper contentCopy={nickName}>
                      {`${nickName}`}
                    </CopyWrapper>
                  </div>
                ) : (
                  "-"
                )}
              </div>
              <div style={{ width: "220px", borderRight: "1px solid #eaeaea" }}>
                {email ? (
                  <div className="cursor-pointer">
                    <CopyWrapper contentCopy={email}>{`${email}`}</CopyWrapper>
                  </div>
                ) : (
                  "-"
                )}
              </div>
              <div style={{ width: "140px", borderRight: "1px solid #eaeaea" }}>
                <div className="text-center" style={{ minWidth: 80 }}>
                  <div className="d-flex flex-column gap-1">
                    <div className="cursor-pointer  d-flex gap-2 align-items-center whitespace-nowrap">
                      <div style={{ width: "25px", marginLeft: 20 }}>
                        {imgPlatform && platform !== "-" && (
                          <img
                            src={imgPlatform}
                            width={25}
                            height={25}
                            alt="platform"
                          />
                        )}
                      </div>
                      <div className="cursor-pointer">
                        {t(capitalizeFirstLetter(platform))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div style={{ width: "200px" }}>
                <div style={{ minWidth: 160 }}>
                  <CopyWrapper contentCopy={item?.uuid}>
                    {item?.uuid || "-"}
                  </CopyWrapper>
                </div>
              </div>
            </div>
          );
        },
      },

      {
        Header: t("Device Info"),
        accessor: "Device Info",
        thClass: "align-middle  text-end px-0",
        filterable: false,
        sortable: false,
        thWidth: 650,
        thComponent: () => (
          <table className="th-border-right-1px  chat-log-px-0 w-100">
            <thead>
              <tr>
                <th
                  className="whitespace-nowrap text-center th-border-bottom-1px pb-2 none-sticky"
                  colSpan={4}
                >
                  {t("Device Info")}
                </th>
              </tr>
              <tr>
                <tr>
                  <th
                    className="whitespace-nowrap text-center pb-0 pt-2 cursor-pointer none-sticky"
                    style={{ width: "150px" }}
                  >
                    {t("App Version")}
                  </th>
                  <th
                    className="whitespace-nowrap text-center pb-0 pt-2 cursor-pointer none-sticky"
                    style={{ width: "150px" }}
                  >
                    {t("IP")}
                  </th>
                  <th
                    className="whitespace-nowrap text-center pb-0 pt-2 cursor-pointer none-sticky"
                    style={{ width: "150px" }}
                  >
                    {t("Country")}
                  </th>

                  <th
                    className="whitespace-nowrap text-center pb-0 pt-2 cursor-pointer none-sticky"
                    style={{ width: "200px" }}
                  >
                    {t("Address")}
                  </th>
                </tr>
              </tr>
            </thead>
          </table>
        ),
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          const appVersion = item?.appVersion;
          const ip = item?.ipAddress;
          const countryCode = item?.countryCode;

          let deviceModel = item?.deviceModel;
          const os = item?.os;
          if (os === "ios") {
            deviceModel = deviceModel
              ? IPHONE_MODELS[deviceModel as keyof typeof IPHONE_MODELS] ??
              deviceModel
              : "";
          }
          const country = countries.find(
            (item) => item?.code == countryCode
          ) || {
            name_korea: item?.country,
            name: item?.country,
            flags: "",
          };

          const lat = item?.latitude;
          const lng = item?.longitude;
          const address = item?.address;

          return (
            <div className="d-flex text-center td-border-right-1px chat-log-px-0 align-items-center">
              <div style={{ minWidth: "150px" }}>
                <div className="cursor-pointer">
                  {appVersion ? (
                    <CopyWrapper contentCopy={appVersion}>
                      {appVersion}
                    </CopyWrapper>
                  ) : (
                    "-"
                  )}
                </div>
              </div>
              <div
                style={{
                  minWidth: "150px",
                  borderLeft: "1px solid #eaeaea",
                  borderRight: "1px solid #eaeaea",
                }}
                className="div-sticky"
              >
                <div className="cursor-pointer ms-2">
                  {ip ? (
                    <CopyWrapper contentCopy={ip}>{`${ip}`}</CopyWrapper>
                  ) : (
                    "-"
                  )}
                </div>
              </div>

              <div
                style={{ minWidth: "150px", borderRight: "1px solid #eaeaea" }}
              >
                <div className="cursor-pointer d-flex gap-2 align-items-center justify-content-center">
                  {country && (
                    <>
                      {countryCode && (
                        <img
                          src={country?.flags}
                          width={20}
                          height={20}
                          alt="profile"
                        />
                      )}
                      <div className="cursor-pointer">
                        {i18n?.language === "ko"
                          ? country?.name_korea
                          : country?.name}
                      </div>
                    </>
                  )}
                </div>
              </div>

              <div
                style={{
                  width: "200px",
                  textAlign: "center",
                  margin: "0 20px",
                }}
              >
                {lat && lng ? (
                  <div>
                    <a
                      href={`https://www.google.com/maps/search/${lat},${lng}/@${lat},${lng},17z?entry=ttu`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {address ? (
                        <CopyWrapper contentCopy={address}>
                          {address}
                        </CopyWrapper>
                      ) : (
                        <span className="d-flex align-items-center gap-1 w-100 justify-content-center">
                          <i className="ri-map-pin-line"></i> {t("Location")}
                        </span>
                      )}
                    </a>
                  </div>
                ) : (
                  "-"
                )}
              </div>
            </div>
          );
        },
      },
      {
        Header: t("Contact Info"),
        accessor: "Contact Info",
        thClass: "align-middle  text-end px-0",
        filterable: false,
        sortable: false,
        thWidth: 500,
        thComponent: () => (
          <table className="th-border-right-1px  chat-log-px-0 w-100">
            <thead>
              <tr>
                <th
                  className="whitespace-nowrap text-center th-border-bottom-1px pb-2 none-sticky"
                  colSpan={4}
                >
                  {t("Contact Info")}
                </th>
              </tr>
              <tr>
                <tr>
                  <th
                    className="whitespace-nowrap text-center pb-0 pt-2 cursor-pointer none-sticky"
                    style={{ width: "150px" }}
                  >
                    {t("Contact Name")}
                  </th>
                  <th
                    className="whitespace-nowrap text-center pb-0 pt-2 cursor-pointer none-sticky"
                    style={{ width: "150px" }}
                  >
                    {t("Contact Phone")}
                  </th>

                  <th
                    className="whitespace-nowrap text-center pb-0 pt-2 cursor-pointer none-sticky"
                    style={{ width: "200px" }}
                  >
                    {t("Contact Email")}
                  </th>
                </tr>
              </tr>
            </thead>
          </table>
        ),
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          const contactName = item?.contactName;
          const contactPhone = item?.contactPhone;
          const contactEmail = item?.contactEmail;

          return (
            <div className="d-flex text-center td-border-right-1px chat-log-px-0 align-items-center">
              <div style={{ width: "150px" }}>
                <div className="cursor-pointer">
                  {contactName ? (
                    <CopyWrapper contentCopy={contactName}>
                      {contactName}
                    </CopyWrapper>
                  ) : (
                    "-"
                  )}
                </div>
              </div>
              <div
                style={{
                  width: "150px",
                  borderLeft: "1px solid #eaeaea",
                  borderRight: "1px solid #eaeaea",
                }}
                className="div-sticky"
              >
                <div className="cursor-pointer ms-2">
                  {contactPhone ? (
                    <CopyWrapper
                      contentCopy={contactPhone}
                    >{`${contactPhone}`}</CopyWrapper>
                  ) : (
                    "-"
                  )}
                </div>
              </div>

              <div
                style={{
                  width: "200px",
                  textAlign: "center",
                  margin: "0 20px",
                }}
              >
                <div>
                  {contactEmail ? (
                    <CopyWrapper
                      contentCopy={contactEmail}
                    >{`${contactEmail}`}</CopyWrapper>
                  ) : (
                    "-"
                  )}
                </div>
              </div>
            </div>
          );
        },
      },

      {
        Header: t("Process Admin"),
        accessor: "Process Admin",
        thClass: "align-middle  text-end px-0",
        filterable: false,
        sortable: false,
        thWidth: 650,
        thComponent: () => (
          <table className="th-border-right-1px  chat-log-px-0 w-100">
            <thead>
              <tr>
                <th
                  className="whitespace-nowrap text-center th-border-bottom-1px pb-2 none-sticky"
                  colSpan={4}
                >
                  {t("Process Admin")}
                </th>
              </tr>
              <tr>
                <tr>
                  <th
                    className="whitespace-nowrap text-center pb-0 pt-2 cursor-pointer none-sticky"
                    style={{ width: "80px" }}
                  >
                    {t("Avatar")}
                  </th>
                  <th
                    className="whitespace-nowrap text-center pb-0 pt-2 cursor-pointer none-sticky"
                    style={{ width: "200px" }}
                  >
                    {t("Nickname")}
                  </th>
                  <th
                    className="whitespace-nowrap text-center pb-0 pt-2 cursor-pointer none-sticky"
                    style={{ width: "220px" }}
                  >
                    {t("Email")}
                  </th>
                  <th
                    className="whitespace-nowrap text-end pb-0 pt-2 cursor-pointer none-sticky"
                    style={{ width: "150px" }}
                  >
                    {t("Updated at")}
                  </th>
                </tr>
              </tr>
            </thead>
          </table>
        ),
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          const inquiryReplies = item?.inquiryReplies?.[0];
          const avatar: any = inquiryReplies?.replyByAdmin?.imageUrl;
          const nickName: any = inquiryReplies?.replyByAdmin?.name;
          const email: any = inquiryReplies?.replyByAdmin?.username;
          const last_updated_at: any = inquiryReplies?.updatedAt;

          const date = formatDateStringToKorea(last_updated_at);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="d-flex text-center td-border-right-1px chat-log-px-0 align-items-center">
              <div style={{ width: "80px" }}>
                <div
                  className="w-100 text-center "
                  style={{ minWidth: "60px" }}
                >
                  <div
                    style={{ width: "45px" }}
                    className="m-auto cursor-pointer"
                    onClick={() => setLinkImage((prev: any) => avatar)}
                  >
                    {inquiryReplies ? (
                      <img
                        src={avatar || NO_IMAGE_USER}
                        className="rounded-circle avatar-sm"
                        alt="thumbnail"
                        onError={({ currentTarget }) => {
                          currentTarget.onerror = null; // prevents looping
                          currentTarget.src = NO_IMAGE_USER;
                        }}
                      />
                    ) : (
                      "-"
                    )}
                  </div>
                </div>
              </div>
              <div
                style={{
                  width: "200px",
                  borderLeft: "1px solid #eaeaea",
                  borderRight: "1px solid #eaeaea",
                }}
                className="div-sticky"
              >
                {nickName ? (
                  <div className="cursor-pointer">
                    <CopyWrapper contentCopy={nickName}>
                      {`${nickName}`}
                    </CopyWrapper>
                  </div>
                ) : (
                  "-"
                )}
              </div>
              <div style={{ width: "220px", borderRight: "1px solid #eaeaea" }}>
                {email ? (
                  <div className="cursor-pointer">
                    <CopyWrapper contentCopy={email}>{`${email}`}</CopyWrapper>
                  </div>
                ) : (
                  "-"
                )}
              </div>

              <div style={{ width: "150px", paddingRight: 16 }}>
                <div className="text-end">
                  {last_updated_at ? (
                    <span>
                      <span>{arrDate?.[0] || ""}</span> <br />{" "}
                      <span className="text-secondary">
                        {arrDate?.[1] || ""}
                      </span>{" "}
                    </span>
                  ) : (
                    "-"
                  )}
                </div>
              </div>
            </div>
          );
        },
      },

      {
        Header: t("Latest Reply"),
        accessor: "inquiryReplies",
        filterable: true,
        sortable: false,
        thClass: "align-middle whitespace-nowrap th-border-right-1px",
        thWidth: 250,
        Cell: (cell: any) => {
          const replyContent = cell?.value?.[0]?.contents;

          return (
            <div className="td-border-right-1px">
              {replyContent ? (
                <CopyWrapper
                  contentCopy={replyContent}
                  style={{ minWidth: "220px" }}
                >
                  <CollapseContent
                    style={{ maxWidth: "350px", whiteSpace: "pre-line" }}
                    dataOriginal={replyContent}
                    isRank={false}
                    isInlineBlock={true}
                    isShowModal={true}
                    titleModal={t("Content")}
                  />
                </CopyWrapper>
              ) : (
                "-"
              )}
            </div>
          );
        },
      },
      {
        Header: t("Created at"),
        accessor: "createdAt",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "align-middle text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "80px" }}>
              {cell?.value ? (
                <span>
                  <span>{arrDate?.[0] || ""}</span> <br />{" "}
                  <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
                </span>
              ) : (
                "-"
              )}
            </div>
          );
        },
      },

      {
        Header: t("Button Action"),
        thClass: "align-middle text-center",
        thWidth: 110,
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          return (
            <ul
              className="list-inline d-flex flex-wrap hstack gap-2 mb-0 "
              style={{ justifyContent: "center" }}
            >
              <TooltipCustom
                title={t("View Detail")}
                id={`view-md-${item?.id}`}
              >
                <Link
                  className="btn btn-sm btn-soft-primary edit-item-btn"
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setItemToDetail(item);
                    setIsShowDetail(false);
                    setTabDetailActive(null);
                  }}
                >
                  <i className="ri-eye-fill align-bottom "></i>
                </Link>
              </TooltipCustom>

              <TooltipCustom
                title={t("Button Delete")}
                id={`delete-md-${item?.id}`}
              >
                <Link
                  className="btn btn-sm btn-soft-danger edit-item-btn"
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setItemToDelete(item);
                  }}
                >
                  <i className="ri-delete-bin-3-fill align-bottom"></i>
                </Link>
              </TooltipCustom>
            </ul>
          );
        },
      },
    ],
    [i18n?.language, inquiries?.pagination?.total, query?.page]
  );

  const handleChangePage = useCallback((page: any) => {
    setQuery({ page: page + 1 });
  }, []);

  const handleChangeSorting = useCallback((sortBy: any) => {
    setQuery((_prev: any) => {
      return { ..._prev, ...sortBy };
    });
  }, []);

  const onCloseImageClick = () => {
    setLinkImage(null);
  };

  const handleActionDelete = async (id: any) => {
    if (!id) return;
    
    try {
      setIsConfirmLoading((_prev) => true);
      const response: any = await inquiryListApi?.deleteInquiry(id);
      console.log(response);
      if (response?.code == 200) {
        loadTableData();
        setIsConfirmLoading((_prev) => false);
        setItemToDelete(false);
        toast(
          `${t("The inquiry has been deleted.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        setIsConfirmLoading((_prev) => false);
        toast(`${response?.message}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsConfirmLoading((_prev) => false);
      toast(`${error || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const handleCloseModal = () => {
    setItemToDetail(null);

    if (!isShowDetail) {
      loadTableData();
    }
  };

  useEffect(() => {
    loadTableData();
  }, [dispatch, JSON.stringify(query)]);

  useEffect(() => {
    const handleCallAllOption = async () => {
      try {
        const [inquiryTypes]: any = await Promise.all([
          inquiryListApi.inquiryTypes(),
        ]);

        if (inquiryTypes?.data) {
          const formatOptionType = inquiryTypes?.data?.map((item: any) => ({
            label: item?.name,
            value: item?.id,
          }));
          setDataInquiryTypes(formatOptionType);
        }
      } catch (error: any) {
        return error;
      }
    };
    handleCallAllOption();
  }, []);

  useEffect(() => {
    document.title = `${t("Inquiry")} | OnnyJob`;
    document.body.classList.remove("vertical-sideinquiry-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t("Inquiry")} pageTitle={t("Home")} />
          <Row>
            <Col lg={12}>
              <Card
                id="customerList"
                style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
              >
                <CardHeader className="border-0">
                  <div className="d-block d-xl-flex justify-content-between align-items-start">
                    <div
                      className="d-flex w-100 flex-wrap gap-3 gap-md-2 menu-card-statistics justify-content-start mb-3 mb-xl-2 position-relative"
                      style={{ maxWidth: "100%" }}
                    >
                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Total")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    // end={inquiries?.pagination?.total || 0 }
                                    end={summary?.all || 0}
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>

                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Total Pending")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={summary?.pending || 0}
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>

                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Total In-Progress")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={summary?.in_progress || 0}
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>

                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Total Resolved")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={summary?.resolved || 0}
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>

                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Total Closed")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={summary?.closed || 0}
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </div>
                  </div>
                </CardHeader>
                <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                  <CollapseFilter>
                    <Row className="g-4 align-items-center mt-0 ">
                      <Col sm={12} md={3} xl={3} xxl={3} className="mt-3 ">
                        <LabelWrapper
                          label={t("Content")}
                          isShow={!!contentSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Content")}...`}
                            value={contentSearch}
                            onChange={(e) => setContentSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col sm={12} md={3} xl={3} xxl={3} className="mt-3 ">
                        <LabelWrapper
                          label={t("Nickname")}
                          isShow={!!nicknameSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Nickname")}...`}
                            value={nicknameSearch}
                            onChange={(e) => setNicknameSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col sm={12} md={3} xl={3} xxl={3} className="mt-3">
                        <LabelWrapper label={t("Email")} isShow={!!emailSearch}>
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Email")}...`}
                            value={emailSearch}
                            onChange={(e) => setEmailSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col sm={12} md={3} xl={3} xxl={3} className="mt-3 ">
                        <LabelWrapper label={t("UUID")} isShow={!!uuidSearch}>
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("UUID")}...`}
                            value={uuidSearch}
                            onChange={(e) => setUUIDSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col sm={12} md={3} xl={3} xxl={3} className="mt-3 ">
                        <LabelWrapper
                          label={t("Contact Name")}
                          isShow={!!contactNameSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Contact Name")}...`}
                            value={contactNameSearch}
                            onChange={(e) =>
                              setContactNameSearch(e.target.value)
                            }
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col sm={12} md={3} xl={3} xxl={3} className="mt-3 ">
                        <LabelWrapper
                          label={t("Contact Phone")}
                          isShow={!!contactPhoneSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Contact Phone")}...`}
                            value={contactPhoneSearch}
                            onChange={(e) =>
                              setContactPhoneSearch(e.target.value)
                            }
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col sm={12} md={3} xl={3} xxl={3} className="mt-3 ">
                        <LabelWrapper
                          label={t("Contact Email")}
                          isShow={!!contactEmailSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Contact Email")}...`}
                            value={contactEmailSearch}
                            onChange={(e) =>
                              setContactEmailSearch(e.target.value)
                            }
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col sm={12} md={3} xl={3} xxl={3} className="mt-3 ">
                        <LabelWrapper label={t("Inquiry Type")} isShow={true}>
                          <DropdownStatusNew
                            name="type"
                            dataList={dataInquiryTypes || []}
                            placeholder={`${t("Select Status")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={typeSearch}
                            onChangeSelect={(e: any) => setTypeSearch(e?.value)}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Status")} isShow={true}>
                          <DropdownStatusNew
                            name="status"
                            dataList={INQUIRY_STATUS || []}
                            placeholder={`${t("Select Status")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={statusSearch}
                            onChangeSelect={(e: any) =>
                              setStatusSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_INQUIRY_STATUS}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-sm-3 mt-md-3 mt-3 date-picker-wrapper-custom"
                      >
                        <LabelWrapper
                          label={t("Date")}
                          isShow={!!startDate || !!endDate}
                        >
                          <DatePickerCustom
                            startDate={startDate || null}
                            endDate={endDate || null}
                            onChangePicker={(values: any) =>
                              setDateSearch((_prev: any) => values)
                            }
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={6}
                        xl={6}
                        xxl={6}
                        className="hstack gap-1 justify-content-center justify-content-md-end mt-sm-4 mt-md-3"
                      >
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary me-1"
                            onClick={searchData}
                          >
                            <i className="ri-search-line align-bottom me-1"></i>{" "}
                            {t("Button Search")}
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary fs-14"
                            onClick={resetData}
                          >
                            <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                            {t("Button Reset")}
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </CollapseFilter>
                </div>
                <CardBody className="pt-3">
                  <div>
                    <TableContainer
                      className="custom-header-css"
                      divClass="table-responsive table-card"
                      tableClass={`align-middle table-bordered-dashed sticky-table-inquiry-management`}
                      theadClass="table-light text-muted"
                      columns={columns}
                      data={inquiries?.items?.length ? inquiries?.items : []}
                      customPageSize={query.limit}
                      customPageIndex={query.page - 1}
                      totalRecords={inquiries?.pagination?.total}
                      customPageCount={Math.ceil(
                        Number(inquiries?.pagination?.total) /
                        Number(query.limit)
                      )}
                      handleChangePage={handleChangePage}
                      manualSorting={true}
                      sorting={{
                        sortBy: query.sortBy,
                        orderBy: query.orderBy,
                      }}
                      handleChangeSorting={handleChangeSorting}
                      isLoading={isInquiryLoading}
                    />
                  </div>
                  <ToastContainer closeButton={false} limit={1} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        <ModalPreview
          type={linkImage?.isVideo ? "VIDEO" : "IMAGE"}
          isOpen={!!linkImage?.url}
          url={linkImage?.url}
          content={linkImage?.content}
          onClose={() => onCloseImageClick()}
        />

        <ModalMultiPreview
          isOpen={!!linkImage?.urls}
          urls={linkImage?.urls || []}
          content={linkImage?.content}
          onClose={() => onCloseImageClick()}
        />

        {itemToDetail && (
          <Modal
            isOpen={!!itemToDetail}
            centered={true}
            size="xl"
            className="modal-fullscreen"
            scrollable={false}
          >
            <ModalHeader toggle={handleCloseModal}>
              {t("Inquiry Detail")}
            </ModalHeader>
            <ModalBody>
              <InquiryListDetail
                inquiryID={itemToDetail?.id}
                setLinkImage={setLinkImage}
                tabDetailActive={tabDetailActive}
                dataInquiryTypes={dataInquiryTypes}
              />
            </ModalBody>
          </Modal>
        )}

        {itemToDelete && (
          <ModalConfirm
            header={t("Delete")}
            isOpen={!!itemToDelete}
            isLoading={isConfirmLoading}
            onClose={() => setItemToDelete(false)}
            onConfirm={() => handleActionDelete(itemToDelete?.id)}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default InquiryList;
